import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { Menu } from '../../MarketingCampaigns.promo.services'
import { getOffersFromConfig, getProductDetailsFromConfig } from '../../../../utils/product'
import { normalizeShopIds } from '../../CampaignModalSkeleton/CampaignModalSkeleton.helpers'
import { ProductDiscountRuleState } from './types'
import { validateProductDiscountRule } from './validate'
import { buildProductDiscountFormValues } from './buildFormValues'
import { ProductDiscountRuleStep } from './RuleStep.view'
import { ProductDiscountConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
		Définissez une <strong style={{ color: '#212121' }}>réduction en pourcentage</strong> sur une
		sélection de <strong style={{ color: '#212121' }}>produits</strong>. Seuls les produits présents
		sur <strong style={{ color: '#212121' }}>toutes</strong> les cartes sélectionnées apparaissent.
	</Typography>
)

function getInitialRuleFromCampaign(
	campaign: any,
	menus: Menu,
): ProductDiscountRuleState {
	const ids = normalizeShopIds(campaign.shopIds)
	const sid = ids[0]
	const offers =
		sid && campaign.config?.products
			? getOffersFromConfig(menus, campaign.config.products, sid)
			: []
	const choosed =
		sid && campaign.config?.products
			? getProductDetailsFromConfig(menus, campaign.config.products, sid, true)
			: []
	return {
		discount: campaign.config?.discount?.value ?? null,
		products: campaign.config?.products || [],
		purchasedProducts: choosed,
		selectedProducts: offers,
		disabledPurshasedProducts: [],
	}
}

export const productDiscountDefinition: CampaignDefinition<ProductDiscountRuleState> = {
	type: CampaignType.PRODUCT_DISCOUNT,
	RuleStep: ProductDiscountRuleStep,
	ConfirmationSummary: ProductDiscountConfirmationSummary,
	defaultRule: {
		discount: null,
		products: [],
		purchasedProducts: [],
		selectedProducts: [],
		disabledPurshasedProducts: [],
	},
	validateRule: validateProductDiscountRule,
	buildFormValues: buildProductDiscountFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'optional',
	showOrderTypesInConfirmation: true,
	forceDeliveryOrderType: false,
	allowsPermanent: true,
}
